export default __webpack_public_path__ + "static/kalidao-2d6322ff39386d698a4b5c1358049c5d.jpg";